"use strict";
Object.defineProperty(exports, Symbol.toStringTag, { value: "Module" });
const react = require("react");
const useAsyncDebouncer = require("./useAsyncDebouncer.cjs");
function useAsyncDebouncedCallback(fn, options) {
  const asyncDebouncedFn = useAsyncDebouncer.useAsyncDebouncer(fn, options).maybeExecute;
  return react.useCallback(
    (...args) => asyncDebouncedFn(...args),
    [asyncDebouncedFn]
  );
}
exports.useAsyncDebouncedCallback = useAsyncDebouncedCallback;
//# sourceMappingURL=useAsyncDebouncedCallback.cjs.map
